import { useEffect } from "react";

/**
 * Hides the global Elido Nexus widget (loaded via /widget.js → #elido-widget-root)
 * while a route that has its own chat preview is mounted. Restores visibility
 * on unmount.
 *
 * Why: the widget persists on document.body across SPA navigations (singleton),
 * and on /skapa-ai-agent/utkast/* it competes with the in-page sandbox
 * preview, distracting the user and looking unprofessional.
 */
export default function HideGlobalWidget() {
  useEffect(() => {
    const host = document.getElementById("elido-widget-root");
    let prev = null;
    if (host) {
      prev = host.style.display;
      host.style.display = "none";
    }
    return () => {
      const h = document.getElementById("elido-widget-root");
      if (h) h.style.display = prev || "";
    };
  }, []);
  return null;
}
